/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import '../styles/horasExtras.css';

// Components.
import { 
  Grid, 
  TextField, 
  Typography, 
  Button,  
  Tooltip,
  Autocomplete,
  Select,
  MenuItem,
  Box,
  InputLabel,
  FormControl,
  useMediaQuery,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';

import Heading from '../components/heading/Heading';
import Formatter from '../scripts/formatters';
import Item from '../components/custom/Item';
import CustomNoRowsOlverlay from '../components/custom/CustomNoRowsOlverlay';
import msgAlerta from '../scripts/alert';
import msgNotificacion from '../scripts/notification';
import SolicitudesDataGrid from '../components/styledDataGrid/SolicitudesDataGrid';
import FormHorasExtrasPdf from '../components/reactPDF/FormHorasExtrasPdf';
import FormHorasExtrasConsolidadoPdf from '../components/reactPDF/FormHorasExtrasConsolidadoPdf';

// Redux
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';
import { PAGE_SIZE, NAME_PROJECT } from '../redux/constants/index';

// Iconos
import DoneIcon from '@mui/icons-material/Done';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import BlockIcon from '@mui/icons-material/Block';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CancelIcon from '@mui/icons-material/Cancel';

// Services
import HorasExtrasService from '../services/horasExtrasService';
import EmpleadoService from '../services/empleadoService';

// Excel
import * as XLSX from 'xlsx';

export default function HorasExtras() {
  const dispatch = useDispatch()
  const userLogin = JSON.parse(localStorage.getItem('user'))
  const isMobile = useMediaQuery('(max-width: 740px)')

  // States
  const [dataHorasExtras, setDataHorasExtras] = useState([])
  const [dataHorasExtrasSelected, setDataHorasExtrasSelected] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [loading, setLoading] = useState(false)
  const [printPdf, setPrintPdf] = useState(false)
  const [tipoReporte, setTipoReporte] = useState('individual') // 'individual' o 'consolidado'
  const [filtrosReporte, setFiltrosReporte] = useState({})
  const [selectionModel, setSelectionModel] = useState()
  const [codigoHorasExtras, setCodigoHorasExtras] = useState(null)
  const [dataEmpleados, setDataEmpleados] = useState([])
  const [dataEstados, setDataEstados] = useState([])    
  const [empleadoSelected, setEmpleadoSelected] = useState(null)
  const [valueFechas, setValueFechas] = useState({ fechaIni: '', fechaFin: '' })
  const [valueSelect, setValueSelect] = useState({ tipoSelected: '', estadoSelected: '' })

  // Modal de aprobación
  const [modalAprobacion, setModalAprobacion] = useState({
    open: false,
    tipo: '', // 'aprobar' o 'rechazar' o 'aplicar'
    idHorasExtras: null,
    motivo: '',
    requiereMotivo: false // Flag para indicar si se requiere motivo al aplicar
  })

  // Modal de anulación
  const [modalAnulacion, setModalAnulacion] = useState({
    open: false,
    idHorasExtras: null,
    motivo: ''
  });

  // Modal de Softland
  const [modalSoftlandOpen, setModalSoftlandOpen] = useState(false);
  const [dataNominas, setDataNominas] = useState([]);
  const [dataNumerosNomina, setDataNumerosNomina] = useState([]);
  const [softlandForm, setSoftlandForm] = useState({
    nomina: '',
    numeroNomina: ''
  });

  // Columns
  const columns = [
    {
      field: 'IdHorasExtras',
      headerName: 'ID',
      width: 80,
      align: 'center',
      headerAlign: 'center',
      resizable: false
    },
    {
      field: 'CodEmpleado',
      headerName: 'Código Empleado',
      width: 130,
      align: 'center',
      headerAlign: 'center',
      resizable: false
    },
    {
      field: 'NombreEmpleado',
      headerName: 'Nombre Empleado',
      minWidth: 200,
      align: 'left',
      headerAlign: 'left',
      flex: 1,
    },
    {
      field: 'FechaTrabajo',
      headerName: 'Fecha Trabajo',
      width: 140,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ( value ) => Formatter.dateFormatter(value)
    },
    {
      field: 'TipoMarcacion',
      headerName: 'Tipo',
      width: 100,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: 'HoraEsperada',
      headerName: 'Hora Esperada',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: (value) => {
        if (!value) return '';
        
        // Si viene como string de hora (HH:MM:SS), mostrarlo directamente
        if (typeof value === 'string' && value.includes(':') && !value.includes('T')) {
          return value;
        }
        
        // Si viene como string ISO (1970-01-01T08:00:00.000Z), extraer solo la hora
        if (typeof value === 'string' && value.includes('T')) {
          const timePart = value.split('T')[1];
          if (timePart) {
            const timeWithoutMs = timePart.split('.')[0]; // Remover milisegundos
            return timeWithoutMs.substring(0, 5); // Solo HH:MM
          }
        }
        
        // Si viene como Date, extraer solo la hora
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
          const timeString = date.toTimeString().split(' ')[0];
          return timeString.substring(0, 5); // Solo HH:MM
        }
        
        return value; // Fallback
      }
    },
    {
      field: 'HoraReal',
      headerName: 'Hora Real',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: (value) => {
        if (!value) return '';
        
        // Si viene como string de hora (HH:MM:SS), mostrarlo directamente
        if (typeof value === 'string' && value.includes(':') && !value.includes('T')) {
          return value;
        }
        
        // Si viene como string ISO (1970-01-01T08:00:00.000Z), extraer solo la hora
        if (typeof value === 'string' && value.includes('T')) {
          const timePart = value.split('T')[1];
          if (timePart) {
            const timeWithoutMs = timePart.split('.')[0]; // Remover milisegundos
            return timeWithoutMs.substring(0, 5); // Solo HH:MM
          }
        }
        
        // Si viene como Date, extraer solo la hora
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
          const timeString = date.toTimeString().split(' ')[0];
          return timeString.substring(0, 5); // Solo HH:MM
        }
        
        return value; // Fallback
      }
    },
    {
      field: 'CantidadHoras',
      headerName: 'Horas Extras',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: (value) => `${value} hrs`
    },
    {
      field: 'Estado',
      headerName: 'Estado',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (props) => {
        // Si está anulada, mostrar "Anulado" con el mismo estilo que los otros estados
            if (props.row.IsAnulada) {
              return (
                <div className="MuiDataGrid-overlayWrapperInner MuiDataGrid-cellContent bg-secondary text-white rounded-4 d-flex justify-content-center align-items-center">
                  <i className="fas fa-ban mx-1 py-1"></i>
                  <Typography style={{ fontSize: 13 }} className='me-1'>Anulado</Typography>
                </div>
              )
            }
        
        return (
          <div className={`MuiDataGrid-overlayWrapperInner MuiDataGrid-cellContent ${props.row.CssBg} rounded-4 d-flex justify-content-center align-items-center`}>
            <i className={`${props.row.CssIcon} mx-1 py-1`}></i>
            <Typography style={{ fontSize: 13 }} className='me-1'>{props.value}</Typography>
          </div>
        )
      }
    },
    {
      field: 'Motivo',
      headerName: 'Motivo',
      minWidth: 200,
      align: 'left',
      headerAlign: 'left',
      flex: 1,
    },
  ]
  
  // Functions
  function alertAllowHorasExtras(idHorasExtras) {
    try {
      const horasExtras = idHorasExtras ?? codigoHorasExtras
      setCodigoHorasExtras(horasExtras)
      
      setModalAprobacion({
        open: true,
        tipo: 'aprobar',
        idHorasExtras: horasExtras,
        motivo: ''
      })
    } catch (error) {
      console.error(error)
    }
  }

  function alertRejectHorasExtras(idHorasExtras) {
    try {
      const horasExtras = idHorasExtras ?? codigoHorasExtras
      setCodigoHorasExtras(horasExtras)
      
      setModalAprobacion({
        open: true,
        tipo: 'rechazar',
        idHorasExtras: horasExtras,
        motivo: ''
      })
    } catch (error) {
      console.error(error)
    }
  }

  function alertAnularHorasExtras(idHorasExtras) {
    try {
      const horasExtras = idHorasExtras ?? codigoHorasExtras
      setCodigoHorasExtras(horasExtras)
      
      setModalAnulacion({
        open: true,
        idHorasExtras: horasExtras,
        motivo: ''
      })
    } catch (error) {
      console.error(error)
    }
  }

  function alertAplicarHorasExtras(idHorasExtras) {
    try {
      const horasExtras = idHorasExtras ?? codigoHorasExtras
      setCodigoHorasExtras(horasExtras)
      
      // Buscar la fila de horas extras para verificar el motivo
      const filaHorasExtras = filteredData.find(item => item.IdHorasExtras === horasExtras) || 
                              dataHorasExtras.find(item => item.IdHorasExtras === horasExtras)
      
      // Verificar si el motivo está NULL o vacío
      const motivoVacio = !filaHorasExtras?.Motivo || filaHorasExtras.Motivo.trim() === ''
      
      setModalAprobacion({
        open: true,
        tipo: 'aplicar',
        idHorasExtras: horasExtras,
        motivo: motivoVacio ? '' : filaHorasExtras.Motivo,
        requiereMotivo: motivoVacio // Flag para indicar si se requiere motivo
      })
    } catch (error) {
      console.error(error)
    }
  }

  function exportarExcelHorasExtrasAplicadas() {
    try {
      // Filtrar horas extras con estados: Pendiente (1), Aprobada (2) y Aplicada (5) (excluir anulados)
      const horasExtrasFiltradas = filteredData.filter(item => 
        (item.IdEstado === 1 || item.IdEstado === 2 || item.IdEstado === 5) && !item.IsAnulada
      )
      
      if (horasExtrasFiltradas.length === 0) {
        msgNotificacion('No hay horas extras para exportar en los estados seleccionados', 'warning')
        return
      }

      // Función para formatear horas a AM/PM
      const formatTimeForExcel = (timeValue) => {
        if (!timeValue) return '';
        
        try {
          // Si viene como string de hora (HH:MM:SS), convertirlo
          if (typeof timeValue === 'string' && timeValue.includes(':') && !timeValue.includes('T')) {
            const [hours, minutes] = timeValue.split(':');
            const hour = parseInt(hours, 10);
            const min = parseInt(minutes, 10);
            const ampm = hour >= 12 ? 'PM' : 'AM';
            const displayHour = hour % 12 || 12;
            return `${displayHour}:${min.toString().padStart(2, '0')} ${ampm}`;
          }
          
          // Si viene como string ISO (1970-01-01T17:00:00.000Z), extraer solo la hora
          if (typeof timeValue === 'string' && timeValue.includes('T')) {
            const timePart = timeValue.split('T')[1];
            if (timePart) {
              const timeWithoutMs = timePart.split('.')[0]; // Remover milisegundos
              const [hours, minutes] = timeWithoutMs.split(':');
              const hour = parseInt(hours, 10);
              const min = parseInt(minutes, 10);
              const ampm = hour >= 12 ? 'PM' : 'AM';
              const displayHour = hour % 12 || 12;
              return `${displayHour}:${min.toString().padStart(2, '0')} ${ampm}`;
            }
          }
          
          // Si viene como Date, extraer solo la hora
          const date = new Date(timeValue);
          if (!isNaN(date.getTime())) {
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const displayHour = hours % 12 || 12;
            return `${displayHour}:${minutes.toString().padStart(2, '0')} ${ampm}`;
          }
          
          return timeValue; // Fallback
        } catch (error) {
          return timeValue; // Fallback
        }
      };

      // Preparar los datos para Excel
      const datosExcel = horasExtrasFiltradas.map(item => ({
        'Código Empleado': item.CodEmpleado,
        'Nombre Empleado': item.NombreEmpleado,
        'Fecha Trabajo': Formatter.dateFormatter(item.FechaTrabajo),
        'Tipo Marcación': item.TipoMarcacion,
        'Hora Esperada': formatTimeForExcel(item.HoraEsperada),
        'Hora Real': formatTimeForExcel(item.HoraReal),
        'Horas Extras': item.CantidadHoras,
        'Motivo': item.Motivo || '',
        'Estado': item.Estado
      }))

      // Crear el libro de trabajo
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(datosExcel)
      
      // Ajustar el ancho de las columnas
      const colWidths = [
        { wch: 15 },  // Código Empleado
        { wch: 30 },  // Nombre Empleado
        { wch: 12 },  // Fecha Trabajo
        { wch: 15 },  // Tipo Marcación
        { wch: 15 },  // Hora Esperada
        { wch: 15 },  // Hora Real
        { wch: 12 },  // Horas Extras
        { wch: 30 },  // Motivo
        { wch: 15 }   // Estado
      ]
      ws['!cols'] = colWidths

      // Agregar la hoja al libro
      XLSX.utils.book_append_sheet(wb, ws, 'Horas Extras')

      // Generar el nombre del archivo con fecha actual
      const fechaActual = new Date().toISOString().split('T')[0]
      const nombreArchivo = `Horas_Extras_${fechaActual}.xlsx`

      // Descargar el archivo
      XLSX.writeFile(wb, nombreArchivo)
      
      msgNotificacion(`Excel exportado exitosamente: ${horasExtrasFiltradas.length} registros`, 'success')
    } catch (error) {
      console.error('Error al exportar Excel:', error)
      msgNotificacion('Error al exportar el archivo Excel', 'error')
    }
  }

  function generarReporteConsolidado() {
    try {
      // Validar que haya un empleado seleccionado
      if (!empleadoSelected || !empleadoSelected.value) {
        msgNotificacion('Debe seleccionar un empleado para generar el reporte consolidado', 'warning')
        return
      }

      // Validar que haya fechas seleccionadas
      if (!valueFechas.fechaIni || !valueFechas.fechaFin) {
        msgNotificacion('Debe seleccionar un rango de fechas para generar el reporte consolidado', 'warning')
        return
      }

      if (filteredData.length === 0) {
        msgNotificacion('No hay datos para generar el reporte consolidado', 'warning')
        return
      }

      // Filtrar solo registros con estado "Aprobada" y "Aplicada RRHH" (excluir anulados)
      const datosFiltrados = filteredData.filter(item => 
        (item.Estado === 'Aprobada' || item.Estado === 'Aplicada RRHH') && !item.IsAnulada
      )

      if (datosFiltrados.length === 0) {
        msgNotificacion('No hay registros aprobados o aplicados (RRHH) para generar el reporte consolidado', 'warning')
        return
      }

      // Agrupar datos por empleado y fecha
      const datosConsolidados = {}
      
      datosFiltrados.forEach(item => {
        const clave = `${item.CodEmpleado}_${item.FechaTrabajo}`
        
        if (!datosConsolidados[clave]) {
          datosConsolidados[clave] = {
            CodEmpleado: item.CodEmpleado,
            NombreEmpleado: item.NombreEmpleado,
            FechaTrabajo: item.FechaTrabajo,
            entrada: null,
            salida: null,
            totalHorasExtras: 0,
            estado: item.Estado,
            motivo: item.Motivo,
            JefeInmediato: item.JefeInmediato,
            JefeRRHH: item.JefeRRHH
          }
        }
        
        // Agregar entrada o salida según el tipo
        if (item.TipoMarcacion === 'ENTRADA') {
          datosConsolidados[clave].entrada = {
            horaEsperada: item.HoraEsperada,
            horaReal: item.HoraReal,
            horasExtras: parseFloat(item.CantidadHoras || 0)
          }
        } else if (item.TipoMarcacion === 'SALIDA') {
          datosConsolidados[clave].salida = {
            horaEsperada: item.HoraEsperada,
            horaReal: item.HoraReal,
            horasExtras: parseFloat(item.CantidadHoras || 0)
          }
        } else if (item.TipoMarcacion === 'ESPECIAL') {
          // Para domingos: HoraEsperada = hora real de entrada, HoraReal = hora real de salida
          datosConsolidados[clave].entrada = {
            horaEsperada: item.HoraEsperada, // Hora real de entrada (para domingo)
            horaReal: item.HoraEsperada, // Misma, porque es la hora real de entrada
            horasExtras: 0 // No hay horas extras individuales, es el total
          }
          datosConsolidados[clave].salida = {
            horaEsperada: null, // No hay hora esperada de salida para domingo
            horaReal: item.HoraReal, // Hora real de salida
            horasExtras: 0 // No hay horas extras individuales, es el total
          }
        }
        
        // Sumar horas extras (para ESPECIAL, usar CantidadHoras directamente)
        if (item.TipoMarcacion === 'ESPECIAL') {
          datosConsolidados[clave].totalHorasExtras = parseFloat(item.CantidadHoras || 0)
        } else {
          datosConsolidados[clave].totalHorasExtras += parseFloat(item.CantidadHoras || 0)
        }
      })

      // Convertir a array y ordenar por fecha
      const reporteConsolidado = Object.values(datosConsolidados)
        .sort((a, b) => new Date(a.FechaTrabajo) - new Date(b.FechaTrabajo))

      // Guardar los filtros para el reporte
      setFiltrosReporte({
        fechaIni: valueFechas.fechaIni,
        fechaFin: valueFechas.fechaFin,
        empleado: empleadoSelected?.label || 'Todos los empleados'
      })
      
      // Crear el PDF del reporte consolidado
      setDataHorasExtrasSelected(reporteConsolidado)
      setTipoReporte('consolidado')
      setPrintPdf(true)
      
      msgNotificacion('Reporte consolidado generado exitosamente', 'success')
      
    } catch (error) {
      console.error('Error al generar reporte consolidado:', error)
      msgNotificacion('Error al generar el reporte consolidado', 'error')
    }
  }

  const handleCloseModal = () => {
    setModalAprobacion({
      open: false,
      tipo: '',
      idHorasExtras: null,
      motivo: '',
      requiereMotivo: false
    })
  }

  const handleConfirmAprobacion = () => {
    try {
      // Validar que el motivo sea obligatorio cuando es aprobar o cuando es aplicar y requiere motivo
      if (modalAprobacion.tipo === 'aprobar' && !modalAprobacion.motivo.trim()) {
        msgNotificacion('Debe ingresar un motivo para aprobar las horas extras', 'warning')
        return
      }
      
      if (modalAprobacion.tipo === 'aplicar' && modalAprobacion.requiereMotivo && !modalAprobacion.motivo.trim()) {
        msgNotificacion('Debe ingresar un motivo para aplicar las horas extras', 'warning')
        return
      }
      
      let estado;
      if (modalAprobacion.tipo === 'aprobar') {
        estado = userLogin.CodigoRol === 2 ? 5 : 2; // Si es RRHH (rol 2) va a Aplicada (5), sino Aprobada (2)
      } else if (modalAprobacion.tipo === 'rechazar') {
        estado = 3; // Rechazada
      } else if (modalAprobacion.tipo === 'aplicar') {
        estado = 5; // Aplicada
      }
      
      actualizarEstado(estado, modalAprobacion.idHorasExtras, modalAprobacion.motivo)
      handleCloseModal()
    } catch (error) {
      console.error(error)
    }
  }

  const handleCloseModalAnulacion = () => {
    setModalAnulacion({
      open: false,
      idHorasExtras: null,
      motivo: ''
    })
  }

  const handleConfirmAnulacion = async () => {
    try {
      dispatch(showProgress(true))
      
      const dataRequest = {
        idHorasExtras: modalAnulacion.idHorasExtras,
        idUsuarioAprob: userLogin.CodigoUsuario,
        motivo: modalAnulacion.motivo
      }

      const response = await HorasExtrasService.anularHorasExtras(dataRequest)
      
      if (response.Codigo === 1) {
        msgNotificacion(response.Mensaje, 'success')
        // Recargar datos
        refreshHorasExtras()
      } else {
        msgNotificacion(response.Mensaje, 'error')
      }
      
      handleCloseModalAnulacion()
    } catch (error) {
      console.error('Error al anular horas extras:', error)
      msgNotificacion('Error al anular las horas extras', 'error')
    } finally {
      dispatch(showProgress(false))
    }
  }

  // Funciones para modal de Softland
  const handleOpenModalSoftland = async () => {
    try {
      dispatch(showProgress(true))
      setModalSoftlandOpen(true)
      
      // Cargar nóminas disponibles
      const responseNominas = await HorasExtrasService.getNominas()
      if (responseNominas.Codigo === 1) {
        setDataNominas(responseNominas.Data)
      }
    } catch (error) {
      console.error('Error al cargar nóminas:', error)
      msgNotificacion('Error al cargar las nóminas', 'error')
    } finally {
      dispatch(showProgress(false))
    }
  }

  const handleCloseModalSoftland = () => {
    setModalSoftlandOpen(false)
    setSoftlandForm({ nomina: '', numeroNomina: '' })
    setDataNumerosNomina([])
  }

  const handleChangeSoftlandForm = (field, value) => {
    setSoftlandForm(prev => ({
      ...prev,
      [field]: value
    }))

    // Si cambia la nómina, cargar números de nómina
    if (field === 'nomina') {
      setSoftlandForm(prev => ({
        ...prev,
        numeroNomina: '' // Limpiar número de nómina
      }))
      loadNumerosNomina(value)
    }
  }

  const loadNumerosNomina = async (nomina) => {
    if (!nomina) {
      setDataNumerosNomina([])
      return
    }

    try {
      dispatch(showProgress(true))
      const response = await HorasExtrasService.getNumerosNomina({ nomina })
      if (response.Codigo === 1) {
        setDataNumerosNomina(response.Data)
      }
    } catch (error) {
      console.error('Error al cargar números de nómina:', error)
      msgNotificacion('Error al cargar los números de nómina', 'error')
    } finally {
      dispatch(showProgress(false))
    }
  }

  const handleAplicarSoftland = async () => {
    if (!softlandForm.nomina || !softlandForm.numeroNomina) {
      msgNotificacion('Debe seleccionar una nómina y un número de nómina', 'warning')
      return
    }

    try {
      dispatch(showProgress(true))
      
      const dataRequest = {
        idUsuarioAprob: userLogin.CodigoUsuario,
        fechaInicio: valueFechas.fechaIni,
        fechaFin: valueFechas.fechaFin,
        nomina: softlandForm.nomina,
        numeroNomina: parseInt(softlandForm.numeroNomina)
      }

      const response = await HorasExtrasService.aplicarHorasExtrasSoftland(dataRequest)
      
      if (response.Codigo === 1) {
        msgNotificacion(response.Mensaje, 'success')
        handleCloseModalSoftland()
      } else {
        msgNotificacion(response.Mensaje, 'error')
      }
    } catch (error) {
      console.error('Error al aplicar a Softland:', error)
      msgNotificacion('Error al aplicar las horas extras a Softland', 'error')
    } finally {
      dispatch(showProgress(false))
    }
  }

  const handleChangeFechas = (event) => {
    try {
      setValueFechas({
        ...valueFechas,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  const actualizarEstado = async (estado, horasExtras, motivo = '') => {
    try {
      const data = {
        idHorasExtras: horasExtras,
        idEstado: estado,
        idUsuarioAprob: userLogin.CodigoUsuario,
        motivo: motivo
      }                  

      if (!data.idHorasExtras) {
        msgNotificacion('No ha sido seleccionada la solicitud que desea actualizar', 'warning')
        return
      }

      dispatch(showProgress(true))

      HorasExtrasService.actualizarEstadoHorasExtras(data)
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            dispatch(showProgress(false))
            return
          }

          setTimeout(() => {
            if (response.Codigo === 1) {
              msgAlerta('Éxito!', response.Mensaje, 'success')
              
              refreshHorasExtras()
            } else {
              msgAlerta('Alerta!', response.Mensaje, 'warning')
            }

            dispatch(showProgress(false))
          }, 500);
        })
        .catch((error) => {
          dispatch(showProgress(false))
          msgNotificacion(error, 'error')
        })
    } catch (error) {
      console.error(error)
    }
  }
  
  const getHorasExtras = async (data) => {
    try {
      setLoading(true)
      
      const response = await HorasExtrasService.getHorasExtras(data)
      
      if (!response) {
        msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
        setLoading(false)
        return
      }

      setTimeout(() => {
        if (response.Codigo === 1) {
          setDataHorasExtras(response.Data)
          setFilteredData(response.Data)
        } else {
          msgAlerta('Alerta!', response.Mensaje, 'warning')
          setDataHorasExtras([])
          setFilteredData([])
        }
        
        setLoading(false)
      }, 1000)
      
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }


  const refreshHorasExtras = () => {
    try {
      const data = {
        codEmpleado: userLogin.CodigoEmpleado
      }
      
      getHorasExtras(data)
    } catch (error) {
      console.error(error)
    }
  }

  const getDatosEmpleadosCbo = async () => {
    try {
      const data = {
        codEmpleado: userLogin.CodigoEmpleado
      }
      
      const response = await HorasExtrasService.getEmpleadosSubordinados(data)
      
      if (!response) {
        msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
        return
      }

      if (response.Codigo === 1) {
        // Asegurar que los datos tengan la estructura correcta para Autocomplete
        const empleadosFormateados = (response.Data || []).map(empleado => ({
          value: empleado.CodEmpleado || empleado.EMPLEADO || empleado.value,
          label: empleado.NombreEmpleado || empleado.Nombre || empleado.NOMBRE || empleado.label
        }))
        setDataEmpleados(empleadosFormateados)
      } else {
        msgNotificacion(response.Mensaje, 'warning')
      }
    } catch (error) {
      console.error(error)
      msgNotificacion('Error al obtener datos de empleados', 'error')
    }
  }

  const getDatosEstadosCbo = async () => {
    try {      
      EmpleadoService.getDatosCboSolicitud()
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            return
          }

          if (response.Codigo === 1) {
            const data = response.Data
            setDataEstados(data?.Estados || [])
          } else {
            setDataEstados([])
            msgNotificacion(response.Mensaje, 'warning')
          }
        })
    } catch (error) {
      console.error(error)
      msgNotificacion('Error al obtener datos de estados', 'error')
    }
  }


  const handleChangeSelect = (event) => {
    try {
      setValueSelect({
        ...valueSelect,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  const handleChangeEmpleado = (event, newValue) => {
    try {
      setEmpleadoSelected(newValue)
      // Solo actualizar el estado, el filtro se maneja en el useEffect
    } catch (error) {
      console.error(error)
    }
  }

  // Filtros
  useEffect(() => {
    try {
      let filtered = [...dataHorasExtras]

      // Filtro por empleado
      if (empleadoSelected) {
        filtered = filtered.filter(item => item.CodEmpleado === empleadoSelected.value)
      }

      // Filtro por tipo de marcación
      if (valueSelect.tipoSelected) {
        filtered = filtered.filter(item => item.TipoMarcacion === valueSelect.tipoSelected)
      }

      // Filtro por estado
      if (valueSelect.estadoSelected) {
        if (valueSelect.estadoSelected === 'anulado') {
          // Filtro especial para anulados
          filtered = filtered.filter(item => item.IsAnulada === true)
        } else {
          // Filtro normal por IdEstado
          filtered = filtered.filter(item => item.IdEstado === parseInt(valueSelect.estadoSelected))
        }
      }

      // Filtro por fechas
      if (valueFechas.fechaIni && valueFechas.fechaFin) {
        const fechaIni = new Date(valueFechas.fechaIni)
        const fechaFin = new Date(valueFechas.fechaFin)
        
        filtered = filtered.filter(item => {
          const fechaItem = new Date(item.FechaTrabajo)
          return fechaItem >= fechaIni && fechaItem <= fechaFin
        })
      }

      setFilteredData(filtered)
    } catch (error) {
      console.error(error)
    }
  }, [dataHorasExtras, empleadoSelected, valueSelect, valueFechas])

  useEffect(() => {
    document.title = `Horas Extras - ${NAME_PROJECT}`

    try {      
      dispatch(showProgress(true))
                  
      setTimeout(() => {        
        getDatosEmpleadosCbo()
        getDatosEstadosCbo()
        refreshHorasExtras()
        
        dispatch(showProgress(false))
      }, 1000)
      
    } catch (error) {
      console.error(error)
    }
  }, [])

  useEffect(() => {
    try {
      if (valueSelect.estadoSelected) {
        refreshHorasExtras()
      }
    } catch (error) {
      console.error(error)
    }
  }, [valueSelect.estadoSelected])

  // Función para formatear horas en vista móvil
  const formatTimeForMobile = (timeValue) => {
    if (!timeValue) return '';
    
    try {
      // Si viene como string de hora (HH:MM:SS), convertirlo
      if (typeof timeValue === 'string' && timeValue.includes(':') && !timeValue.includes('T')) {
        const [hours, minutes] = timeValue.split(':');
        return `${hours}:${minutes}`;
      }
      
      // Si viene como string ISO (1970-01-01T17:00:00.000Z), extraer solo la hora
      if (typeof timeValue === 'string' && timeValue.includes('T')) {
        const timePart = timeValue.split('T')[1];
        if (timePart) {
          const timeWithoutMs = timePart.split('.')[0]; // Remover milisegundos
          const [hours, minutes] = timeWithoutMs.split(':');
          return `${hours}:${minutes}`;
        }
      }
      
      // Si viene como Date, extraer solo la hora
      const date = new Date(timeValue);
      if (!isNaN(date.getTime())) {
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      }
      
      return timeValue; // Fallback
    } catch (error) {
      return timeValue; // Fallback
    }
  };

  return <div className='App-content'>

    <Heading className='mt-0 w-100 heading heading-title'>
      <div className='heading-text'>
        <i className='bx bx-time me-2'></i>
        <span>Horas Extras</span>
      </div>

      <div className='d-flex dv-filt-fechas-solic'>
        <div className='d-flex w-100 justify-content-evenly dv-buttons-refresh'>
          <Tooltip title='Refrescar datos'>
            <Button
              variant='outlined'
              className='text-transform-none mx-1'
              color='info'
              startIcon={<RestartAltIcon />}
              onClick={() => refreshHorasExtras()}
              size='small'
            >
              Refrescar
            </Button>
          </Tooltip>

          {!isMobile && (
            <>
              <Tooltip title='Exportar horas extras a Excel'>
                <Button
                  variant='outlined'
                  className='text-transform-none mx-1'
                  color='success'
                  startIcon={<FileDownloadIcon />}
                  onClick={() => exportarExcelHorasExtrasAplicadas()}
                  size='small'
                >
                  Exportar Excel
                </Button>
              </Tooltip>

              {/* Botón de Reporte Consolidado - Solo para Admin (rol 1) y RRHH (rol 2) */}
              {(userLogin.CodigoRol === 1 || userLogin.CodigoRol === 2) && (
                <Tooltip title='Generar reporte consolidado por día'>
                  <Button
                    variant='outlined'
                    className='text-transform-none mx-1'
                    color='primary'
                    startIcon={<AssessmentIcon />}
                    onClick={() => generarReporteConsolidado()}
                    size='small'
                  >
                    Reporte Consolidado
                  </Button>
                </Tooltip>
              )}

              {/* Botón de Aplicar a Softland - Solo para Admin (rol 1) y RRHH (rol 2) */}
              {(userLogin.CodigoRol === 1 || userLogin.CodigoRol === 2) && (
                <Tooltip title="Aplicar horas extras a Softland">
                  <Button
                    variant='outlined'
                    className='text-transform-none mx-1'
                    color='success'
                    startIcon={<i className="fas fa-upload"></i>}
                    onClick={handleOpenModalSoftland}
                    size='small'
                  >
                    Aplicar a Softland
                  </Button>
                </Tooltip>
              )}
            </>
          )}
        </div>

        <div className='d-flex filt-fechas-solic'>
          <TextField
            id='txtFechaInicio'
            name='fechaIni'
            label='Fecha Inicial'
            type='date'
            size='small'
            value={valueFechas.fechaIni}
            onChange={handleChangeFechas}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: 150, marginRight: 1 }}
          />
          <TextField
            id='txtFechaFin'
            name='fechaFin'
            label='Fecha Final'
            type='date'
            size='small'
            value={valueFechas.fechaFin}
            onChange={handleChangeFechas}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: 150 }}
          />
        </div>
      </div>
    </Heading>

    <Grid container spacing={1} paddingX={1} paddingTop={1}>
      <Grid item xs={12} md={3}>
        <Item>
          <Autocomplete
            options={dataEmpleados}
            getOptionLabel={(option) => option.label || ''}
            value={empleadoSelected}
            onChange={handleChangeEmpleado}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Listado de Empleados"
                size="small"
                placeholder="Seleccionar empleado..."
              />
            )}
            renderOption={(props, option) => {
              const { key, ...otherProps } = props;
              return (
                <Box component="li" key={key} {...otherProps}>
                  <Typography variant="body2">
                    {option.value} - {option.label}
                  </Typography>
                </Box>
              );
            }}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            noOptionsText="No hay empleados disponibles"
          />
        </Item>
      </Grid>

      <Grid item xs={12} md={3}>
        <Item>
          <FormControl fullWidth size="small">
            <InputLabel id="tipo-marcacion-label">Tipo de Marcación</InputLabel>
            <Select
              labelId="tipo-marcacion-label"
              id="tipo-marcacion"
              name="tipoSelected"
              value={valueSelect.tipoSelected}
              label="Tipo de Marcación"
              onChange={handleChangeSelect}
            >
              <MenuItem value="">
                <em>Todos los tipos</em>
              </MenuItem>
              <MenuItem value="ENTRADA">ENTRADA</MenuItem>
              <MenuItem value="SALIDA">SALIDA</MenuItem>
            </Select>
          </FormControl>
        </Item>
      </Grid>

      <Grid item xs={12} md={3}>
        <Item>
          <FormControl fullWidth size="small">
            <InputLabel id="estado-horas-extras-label">Estado</InputLabel>
            <Select
              labelId="estado-horas-extras-label"
              id="estado-horas-extras"
              name="estadoSelected"
              value={valueSelect.estadoSelected}
              label="Estado"
              onChange={handleChangeSelect}
            >
              <MenuItem value="">
                <em>Todos los estados</em>
              </MenuItem>
              {dataEstados?.map((item) => {
                return (
                  <MenuItem key={item.Id} value={item.Id.toString()}>{item.Nombre}</MenuItem>
                )
              })}
              <MenuItem value="anulado">
                Anulado
              </MenuItem>
            </Select>
          </FormControl>
        </Item>
      </Grid>

      <Grid item xs={12} md={3}>
        <Item>
          <div className={`d-flex justify-content-end ${isMobile ? 'd-none' : ''}`}>
            {/* <Tooltip title='Selecciona un registro para imprimir'>
            <Button
              variant='contained'
              className='text-transform-none float-right me-2'
              color='info'
              onClick={() => handlePrintRequest(null)}
              size='small'
              startIcon={<PrintIcon />}
            >
              Imprimir
            </Button>
            </Tooltip> */}

            <Button
              variant='contained'
              className='text-transform-none float-right me-2'
              color='error'
              startIcon={<BlockIcon />}
              size='small'
              onClick={() => alertRejectHorasExtras(null)}
            >
              Rechazar
            </Button>

            {/* Botón de Anulación - Solo para Admin (rol 1) y RRHH (rol 2) */}
            {(userLogin.CodigoRol === 1 || userLogin.CodigoRol === 2) && (
              <Button
                variant='contained'
                className='text-transform-none float-right me-2'
                color='warning'
                startIcon={<CancelIcon />}
                size='small'
                onClick={() => alertAnularHorasExtras(null)}
              >
                Anular
              </Button>
            )}

            <Button
              variant='contained'
              className='text-transform-none float-right mx-1'
              color='success'
              onClick={() => userLogin.CodigoRol === 2 ? alertAplicarHorasExtras(null) : alertAllowHorasExtras(null)}
              size='small'
              startIcon={<DoneIcon />}
            >
              {userLogin.CodigoRol === 2 ? 'Aplicar' : 'Aprobar'}
            </Button>
          </div>
        </Item>
      </Grid>
    </Grid>

    <Grid container spacing={1} paddingX={1} paddingTop={1}>
      {isMobile ? (
        <Grid container spacing={1} paddingX={1} paddingTop={1}>
          {filteredData.map((row) => (
            <Grid item xs={12} key={row.IdHorasExtras}>
              <Card sx={{ mb: 1 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Solicitud #{row.IdHorasExtras}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Empleado:</strong> {row.NombreEmpleado}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha Trabajo:</strong> {Formatter.dateFormatter(row.FechaTrabajo)}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Hora Esperada:</strong> {formatTimeForMobile(row.HoraEsperada)}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Hora Real:</strong> {formatTimeForMobile(row.HoraReal)}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Horas Extras:</strong> {row.CantidadHoras}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Tipo:</strong> {row.TipoMarcacion}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Motivo:</strong> {row.Motivo}
                  </Typography>
                  <Typography variant="body2" className={row.IsAnulada ? 'bg-secondary text-white' : row.CssBg} display='flex' alignItems='center' borderRadius={4}>
                    <i className={row.IsAnulada ? 'fas fa-ban mx-1' : `${row.CssIcon} mx-1`}></i>
                    <strong>Estado:</strong><span className={`mx-1 ${row.IsAnulada ? 'bg-secondary text-white px-2 py-1 rounded d-flex align-items-center' : ''}`}>{row.IsAnulada ? <><i className="fas fa-ban me-1"></i>Anulado</> : row.Estado}</span>
                  </Typography>
                  <div style={{ marginTop: '10px' }} >
                    {!row.IsAnulada && (
                      <>
                        <Button
                          variant="contained"
                          color="success"
                          size="small"
                          onClick={() => userLogin.CodigoRol === 2 ? alertAplicarHorasExtras(row.IdHorasExtras) : alertAllowHorasExtras(row.IdHorasExtras)}
                          className="text-transform-none me-2"
                        >
                          {userLogin.CodigoRol === 2 ? 'Aplicar' : 'Aprobar'}
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="small"
                          onClick={() => alertRejectHorasExtras(row.IdHorasExtras)}
                          className="text-transform-none me-2"
                        >
                          Rechazar
                        </Button>
                        {/* Botón de Anulación - Solo para Admin (rol 1) y RRHH (rol 2) */}
                        {(userLogin.CodigoRol === 1 || userLogin.CodigoRol === 2) && (
                          <Button
                            variant="contained"
                            color="warning"
                            size="small"
                            onClick={() => alertAnularHorasExtras(row.IdHorasExtras)}
                            className="text-transform-none me-2"
                          >
                            Anular
                          </Button>
                        )}
                      </>
                    )}
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container spacing={1} paddingX={1} paddingTop={1}>
          <Grid item xs={12} md={12}>
            <Item className='MuiPaper-root-dataGrid-horas-extras'>
              <SolicitudesDataGrid
                rows={filteredData}
                columns={columns}
                getRowId={(row) => row?.IdHorasExtras}
                pageSize={PAGE_SIZE}
                pageSizeOptions={[5, 10, 25, 50, 100]}
                loading={loading}
                localeText={Formatter.localizedTextsMapColumns}
                getRowClassName={(params) => `super-app-theme--${params.row?.Estado}`}
                checkboxSelection
                onRowSelectionModelChange={(selection) => {
                  if (selection.length > 1) {
                    const selectionSet = new Set(selectionModel)
                    const result = selection.filter((s) => !selectionSet.has(s))

                    setSelectionModel(result)
                    setCodigoHorasExtras(result[0])
                  } else {
                    setSelectionModel(selection)
                    setCodigoHorasExtras(selection[0])
                  }
                }}
                rowSelectionModel={selectionModel}
                showCellVerticalBorder
                showColumnVerticalBorder
                density='compact'
                slots={{
                  noRowsOverlay: CustomNoRowsOlverlay
                }}
              />
            </Item>
          </Grid>
        </Grid>
      )}
    </Grid>


    {/* Modal de Aprobación/Rechazo */}
    <Dialog
      open={modalAprobacion.open}
      onClose={handleCloseModal}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {modalAprobacion.tipo === 'aprobar' ? 'Aprobar Horas Extras' : 
         modalAprobacion.tipo === 'rechazar' ? 'Rechazar Horas Extras' : 
         'Aplicar Horas Extras'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {modalAprobacion.tipo === 'aprobar' 
            ? `¿Está seguro que desea aprobar la solicitud #${modalAprobacion.idHorasExtras}?`
            : modalAprobacion.tipo === 'rechazar'
            ? `¿Está seguro que desea rechazar la solicitud #${modalAprobacion.idHorasExtras}?`
            : `¿Está seguro que desea aplicar la solicitud #${modalAprobacion.idHorasExtras}?`
          }
        </DialogContentText>
        {/* Mostrar motivo si es aprobar o si es aplicar y requiere motivo */}
        {(modalAprobacion.tipo === 'aprobar' || (modalAprobacion.tipo === 'aplicar' && modalAprobacion.requiereMotivo)) && (
          <TextField
            autoFocus
            margin="dense"
            label="Motivo (obligatorio)"
            fullWidth
            multiline
            rows={3}
            variant="outlined"
            value={modalAprobacion.motivo}
            onChange={(e) => setModalAprobacion({
              ...modalAprobacion,
              motivo: e.target.value
            })}
            placeholder={modalAprobacion.tipo === 'aplicar' && modalAprobacion.requiereMotivo 
              ? "Ingrese el motivo de la aplicación (obligatorio)..." 
              : "Ingrese el motivo de la aprobación (obligatorio)..."}
            required={true}
            error={!modalAprobacion.motivo.trim()}
            helperText={!modalAprobacion.motivo.trim() 
              ? "El motivo es obligatorio" 
              : ""}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseModal} color="primary">
          Cancelar
        </Button>
        <Button 
          onClick={handleConfirmAprobacion} 
          color={modalAprobacion.tipo === 'aprobar' ? 'success' : 
                 modalAprobacion.tipo === 'rechazar' ? 'error' : 'primary'}
          variant="contained"
        >
          {modalAprobacion.tipo === 'aprobar' ? 'Aprobar' : 
           modalAprobacion.tipo === 'rechazar' ? 'Rechazar' : 'Aplicar'}
        </Button>
      </DialogActions>
    </Dialog>

    {/* Modal de Anulación */}
    <Dialog
      open={modalAnulacion.open}
      onClose={handleCloseModalAnulacion}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Anular Horas Extras
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          ¿Está seguro que desea anular la solicitud #{modalAnulacion.idHorasExtras}?
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label="Motivo de anulación"
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          value={modalAnulacion.motivo}
          onChange={(e) => setModalAnulacion({
            ...modalAnulacion,
            motivo: e.target.value
          })}
          placeholder="Ingrese el motivo de la anulación..."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseModalAnulacion} color="primary">
          Cancelar
        </Button>
        <Button 
          onClick={handleConfirmAnulacion} 
          color="warning"
          variant="contained"
        >
          Anular
        </Button>
      </DialogActions>
    </Dialog>

    {/* Modal de Aplicar a Softland */}
    <Dialog
      open={modalSoftlandOpen}
      onClose={handleCloseModalSoftland}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ pb: 1 }}>
        <i className="fas fa-upload me-2"></i>
        Aplicar a Softland
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <DialogContentText sx={{ mb: 2, fontSize: '0.9rem' }}>
          Aplicar horas extras del período seleccionado a la nómina.
        </DialogContentText>
        
        {/* Mostrar fechas del período */}
        <Box sx={{ mb: 2, p: 1.5, bgcolor: 'grey.100', borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Período:</strong> {valueFechas.fechaIni} - {valueFechas.fechaFin}
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="nomina-label">Nómina</InputLabel>
              <Select
                labelId="nomina-label"
                id="nomina"
                value={softlandForm.nomina}
                label="Nómina"
                onChange={(e) => handleChangeSoftlandForm('nomina', e.target.value)}
              >
                {dataNominas.map((item) => (
                  <MenuItem key={item.NOMINA} value={item.NOMINA}>
                    {item.NOMINA}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="numero-nomina-label">Número</InputLabel>
              <Select
                labelId="numero-nomina-label"
                id="numero-nomina"
                value={softlandForm.numeroNomina}
                label="Número"
                onChange={(e) => handleChangeSoftlandForm('numeroNomina', e.target.value)}
                disabled={!softlandForm.nomina}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 120, // Altura para mostrar solo 3 opciones
                    },
                  },
                }}
              >
                {dataNumerosNomina.map((item) => (
                  <MenuItem key={item.NUMERO_NOMINA} value={item.NUMERO_NOMINA}>
                    {item.NUMERO_NOMINA}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ pt: 1, pb: 2, px: 3 }}>
        <Button onClick={handleCloseModalSoftland} color="primary" size="small">
          Cancelar
        </Button>
        <Button 
          onClick={handleAplicarSoftland} 
          color="success"
          variant="contained"
          size="small"
          disabled={!softlandForm.nomina || !softlandForm.numeroNomina || !valueFechas.fechaIni || !valueFechas.fechaFin}
        >
          <i className="fas fa-upload me-1"></i>
          Aplicar
        </Button>
      </DialogActions>
    </Dialog>

    {tipoReporte === 'consolidado' ? (
      <FormHorasExtrasConsolidadoPdf
        data={dataHorasExtrasSelected}
        print={printPdf}
        setPrint={setPrintPdf}
        filtros={filtrosReporte}
      />
    ) : (
      <FormHorasExtrasPdf
        data={dataHorasExtrasSelected}
        print={printPdf}
        setPrint={setPrintPdf}
      />
    )}
  </div>
}
